import {
  ReviewListSchemaResponse,
  AddBusinessReviewSchema,
  AddBusinessReviewResponseSchema,
} from "@/schemas/review";
import type {
  ReviewListResponse,
  AddBusinessReviewPayload,
  AddBusinessReviewResponse,
} from "@/schemas/review";

import { apiRequest } from "./apiUtils";

export async function getBusinessReviews(
  businessId: number,
  params?: { page?: number; page_size?: number },
): Promise<ReviewListResponse> {
  const url = `review/business`;
  const body = { business_id: businessId, ...(params ?? {}) };
  const data = await apiRequest<unknown>(url, {
    method: "POST",
    body: JSON.stringify({
      ...body,
      page: params?.page ?? 0,
      page_size: params?.page_size ?? 10,
    }),
  });
  return ReviewListSchemaResponse.parse(data);
}

export async function getWorkerReviews(
  workerId: string,
  params?: { page?: number; page_size?: number },
): Promise<ReviewListResponse> {
  const url = `review/worker`;
  const body = { worker_id: workerId, ...(params ?? {}) };
  const data = await apiRequest<unknown>(url, {
    method: "POST",
    body: JSON.stringify({
      ...body,
      page: params?.page ?? 0,
      page_size: params?.page_size ?? 10,
    }),
  });
  return ReviewListSchemaResponse.parse(data);
}

export async function addBusinessReview(
  payload: AddBusinessReviewPayload,
): Promise<AddBusinessReviewResponse> {
  // Validate payload before sending
  AddBusinessReviewSchema.parse(payload);
  const url = `worker/shift/add-business-review`;
  const data = await apiRequest<unknown>(url, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return AddBusinessReviewResponseSchema.parse(data);
}
